var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wl-circular-timer"},[_c('canvas',{ref:"counter",attrs:{"height":_vm.dimensions,"width":_vm.dimensions}})])
}
var staticRenderFns = []

export { render, staticRenderFns }